import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body text-center py-15" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-gray-900 fw-bolder mb-3" }, "Conheça a Lux", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-gray-500 fs-5 mb-8 mx-auto",
  style: {"max-width":"520px"}
}, [
  /*#__PURE__*/_createTextVNode(" A mentora de IA da HackingClub ajuda quando você trava numa máquina, explica payloads e monta planos de estudo com base no seu progresso. Exclusiva para membros "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger fw-bold" }, "Elite"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LuxAvatar = _resolveComponent("LuxAvatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LuxAvatar, {
        size: 120,
        class: "mx-auto mb-6"
      }),
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPlans && _ctx.openPlans(...args)))
      }, " Conhecer o plano Elite ")
    ])
  ]))
}